import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Company } from '@/types';
    import { useForm } from '@inertiajs/vue3';
    import { useQueryClient } from '@tanstack/vue-query';
    import { useI18n } from 'vue-i18n';
    import {
        AlertDialog,
        AlertDialogTrigger,
        AlertDialogContent,
        AlertDialogHeader,
        AlertDialogTitle,
        AlertDialogDescription,
        AlertDialogFooter,
        AlertDialogCancel,
        AlertDialogAction,
    } from '@/components/ui/alert-dialog';
    import { Button } from '@/components/ui/button';
    import { Check } from 'lucide-vue-next';
    import { toast } from 'vue-sonner';
    import QueryKey from '@/enums/QueryKey';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ToggleRestoreCompany',
  props: {
    company: {}
  },
  setup(__props: any) {

    const { t } = useI18n();

    const queryClient = useQueryClient();

    const props = __props;

    const form = useForm({
        id: props.company.id,
    });

    const restoreCompany = () => {
        form.post(route('v2.companies.restore'), {
            onSuccess: () => {
                queryClient.invalidateQueries({ queryKey: [QueryKey.COMPANIES] });
                toast.success(t(`companies.js.restore.success`));
            },
            onError: () => {
                toast.error(t('forms.general.error'));
            },
        });
    };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(AlertDialog), null, {
    default: _withCtx(() => [
      _createVNode(_unref(AlertDialogTrigger), { "as-child": "" }, {
        default: _withCtx(() => [
          _createVNode(_unref(Button), {
            variant: "ghost",
            class: "mr-auto"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('forms.restore')), 1),
              _createVNode(_unref(Check), { class: "text-accent" })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(AlertDialogContent), null, {
        default: _withCtx(() => [
          _createVNode(_unref(AlertDialogHeader), null, {
            default: _withCtx(() => [
              _createVNode(_unref(AlertDialogTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)(`companies.js.restore.title`)), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(AlertDialogDescription), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)(`companies.js.restore.content`)), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(AlertDialogFooter), null, {
            default: _withCtx(() => [
              _createVNode(_unref(AlertDialogCancel), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)(`companies.js.restore.no`)), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(AlertDialogAction), {
                onClick: restoreCompany,
                variant: "default"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)(`companies.js.restore.yes`)), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})